<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-skeleton-loader v-if="$store.state.customers.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Clientes</v-toolbar-title>
          <v-spacer />
           <v-toolbar-items>
            <v-row align="center" justify="end" class="mr-1">
              <v-query-builder :query-map="filters" model="customer" class="mr-1" />
              <v-btn @click="dialogCustomer=true" color="secondary" outlined><v-icon left small>mdi-plus</v-icon>Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <customer-list :show-create="true" @update:create="dialogCustomer = true" />
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog new customer -->
    <v-dialog v-model="dialogCustomer" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Crear cliente</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogCustomer=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="12">
                  <v-text-field v-model.trim="$v.customer.name.$model" :error="$v.customer.name.$error" background-color="white" outlined required single-line dense placeholder="Acme LLC" maxlength="100" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>
                País
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>No podrás cambiar el país una vez que se guarde la información del cliente.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-select v-model="$v.customer.country.$model" :error="$v.customer.country.$error" label="Elige un país" single-line :items="countriesList" item-value="id" item-text="name" hide-details dense height="30" outlined background-color="white">
                    <template v-slot:item="data">
                      <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                    </template>
                  </v-select>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Estado</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-select v-model="$v.customer.state.$model" :error="$v.customer.state.$error" label="Elige un estado" :items="statesList" item-value="id" item-text="name" single-line hide-details dense height="30" outlined background-color="white" no-data-text="No existen estados para el país.">
                    <template v-slot:item="data">
                      <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                    </template>
                  </v-select>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>

            <!-- BR fields -->
            <template v-if="account.country.id === 'BR'">
              <v-list-item>
                <v-list-item-title>Municipio</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-col cols="8">
                    <v-autocomplete v-model="$v.customer.tax_settings.br_city_code.$model" :error="$v.customer.tax_settings.br_city_code.$error" :items="bigChoices.brMunicipality.items" :search-input.sync="bigChoices.brMunicipality.search" @keyup="filterBigChoices('brMunicipality', 'localization.brMunicipalities')" item-text="name" item-value="id" outlined background-color="white" no-data-text="No existen coincidencias para la busqueda" placeholder="Escribe para buscar..." dense hide-details />
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
            </template>
            <!-- end BR field -->

            <v-list-item class="py-1">
              <v-list-item-title>Dirección</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model.trim="$v.customer.address.$model" :error="$v.customer.address.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Código postal</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="4">
                  <v-text-field v-model.trim="$v.customer.zip_code.$model" :error="$v.customer.zip_code.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="mt-4">
              <v-list-item-title>
                <span class="text--secondary font-weight-medium">Información de facturación</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="mt-2">
              <v-list-item-title>
                Moneda de facturación y cobro
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>No podrás cambiar la moneda una vez que se guarde la información del cliente o se cree una factura del cliente.</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-select v-model="$v.customer.currency.$model" :error="$v.customer.currency.$error" label="Elige una moneda" :items="currencies.filter(c => !c.conversion)" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" outlined dense single-line hide-details>
                    <template v-slot:item="data">
                      <v-list-item-title class="font-weight-regular">{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                    </template>
                  </v-select>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                ID Fiscal
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Es el RUT, RUC, RFC, VAT, NIF, NIT o TAX ID del cliente</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.customer.tax_id.$model" :error="$v.customer.tax_id.$error" v-dni="customer.country" background-color="white" outlined single-line dense hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>

            <!-- BR tax settings fields -->
            <template v-if="account.country.id === 'BR'">
              <v-list-item>
                <v-list-item-title>Inscripción municipal</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-text-field v-model.trim="$v.customer.tax_settings.br_municipal_tax_number.$model" :error="$v.customer.tax_settings.br_municipal_tax_number.$error" background-color="white" outlined required single-line dense maxlength="32" hide-details />
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Régimen tributario</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-select v-model="$v.customer.tax_settings.br_tax_regime.$model" :error="$v.customer.tax_settings.br_tax_regime.$error" :items="localization.brTaxRegimes" item-text="name" item-value="id" outlined background-color="white" placeholder="Selecciona una opción" dense hide-details />
                </v-list-item-subtitle>
              </v-list-item>
            </template>
            <!-- end BR tax settings fields -->

            <!-- CL tax settings fields -->
            <template v-if="account.country.id === 'CL'">
              <v-list-item>
                <v-list-item-title>Actividad comercial</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-text-field v-model.trim="$v.customer.tax_settings.cl_activity_description.$model" :error="$v.customer.tax_settings.cl_activity_description.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                </v-list-item-subtitle>
              </v-list-item>
            </template>
            <!-- end CL tax settings fields -->

            <!-- MX tax settings fields -->
            <template v-if="account.country.id === 'MX'">
              <v-list-item>
                <v-list-item-title>Régimen fiscal</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-text-field v-model.trim="$v.customer.tax_settings.mx_tax_scheme.$model" :error="$v.customer.tax_settings.mx_tax_scheme.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                </v-list-item-subtitle>
              </v-list-item>
            </template>
            <!-- end MX tax settings fields -->

            <v-list-item class="mt-4">
              <v-list-item-title>
                <span class="text--secondary font-weight-medium">Información adicional</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="mt-2">
              <v-list-item-title>Propietario del cliente</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.customer.manager.$model" :error="$v.customer.manager.$error" outlined required single-line background-color="white" dense maxlength="64" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="mt-2">
              <v-list-item-title>Email de facturación</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.customer.email.$model" :error="$v.customer.email.$error" outlined required single-line background-color="white" dense maxlength="64" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Teléfono</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.customer.phone.$model" :error="$v.customer.phone.$error" background-color="white" outlined required single-line dense v-if="country" v-mask="`${country.phone_code} # #### ####`" maxlength="16" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Sitio web</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.customer.website.$model" :error="$v.customer.website.$error" background-color="white" outlined required single-line class="pa-0" dense  maxlength="64" :hide-details="true" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer/>
          <v-btn outlined @click="dialogCustomer=false">Cancelar</v-btn>
          <v-btn color="primary" :loading="$store.state.customers.createLoader" @click="postCustomer">Crear cliente</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog new customer -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength, email, url, requiredIf } from 'vuelidate/lib/validators'
import { validateTaxId } from '../../locale/tax-id'
import { validateZipCode } from '../../locale/zip-code'

import CustomerList from '@/components/customer/CustomerList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'

import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    CustomerList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    bigChoices: {
      brMunicipality: {
        search: null,
        items: []
      }
    },
    customer: {
      name: '',
      tax_id: '',
      tax_settings: {
        br_city_code: '',
        br_city_name: '',
        br_municipal_tax_number: '',
        br_tax_regime: '',
        cl_activity_description: '',
        mx_tax_scheme: ''
      },
      country: null,
      currency: '',
      state: '',
      address: '',
      email: '',
      phone: '',
      website: '',
      zip_code: ''
    },
    dialogCustomer: false,
    filters: [
      {
        type: 'text',
        id: 'name',
        label: 'Nombre',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'tax_id',
        label: 'ID Fiscal',
        operators: ['contiene']
      },
      {
        type: 'radio',
        id: 'subscriptions__isnull',
        label: 'Tiene suscripción',
        choices: [
          { label: 'Si', value: 'False' },
          { label: 'No', value: 'True' }
        ]
      },
      {
        type: 'select',
        id: 'subscriptions__status',
        label: 'Estado de la suscripción',
        choices: [
          { value: 'active', label: 'Activo' },
          { value: 'paused', label: 'Pausado' },
          { value: 'needs_attention', label: 'Necesita atención' },
          { value: 'cancelled', label: 'Cancelado' },
          { value: 'finalized', label: 'Finalizado' }
        ]
      },
      {
        type: 'select',
        id: 'sources__status__in',
        label: 'Tarjeta',
        choices: [
          { label: 'Activa', value: 'chargeable' },
          { label: 'Inactiva', value: 'failed' },
          { label: 'En proceso de autorización', value: 'requires_authorization,waiting_authorization' }
        ]
      },
      {
        type: 'text',
        id: 'email',
        label: 'Email',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'country__name',
        label: 'País',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'created',
        label: 'Fecha de creación',
        operators: ['es igual', 'es menor a', 'es mayor a']
      }
    ],
    headers: [
      { text: 'Cliente', value: 'name', class: 'font-weight-bold', sortable: true },
      { text: 'Email', value: 'email', sortable: true },
      { text: 'Creado el', value: 'created', align: 'end', sortable: true }
    ],
    localization: {
      brMunicipalities: [],
      brTaxRegimes: []
    },
    statesList: {}
  }),
  computed: {
    ...mapState({
      countriesList: state => state.generals.countriesList
    }),
    country () {
      return this.customer.country ? this.countriesList.find(country => country.id === this.customer.country) : null
    }
  },
  created () {
    const query = {
      page_size: 100
    }
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/countries',
      query: query
    })
    .then(() => {
      const country = this.countriesList.filter(country => country.id === this.$store.state.auth.account.country.id)[0]
      this.customer.country = country.id
    })

    /**
     * Conditionally imports the 'br' locale module and assigns the 'brMunicipalities' property to the 'localization' object.
     * This is done when the country ID of the current account is 'BR' (Brazil).
     * If the import is successful, the 'brMunicipalities' property is assigned the value from the imported module.
     * If there is an error during the import, the error is logged to the console.
     */
    if (this.account.country.id === 'BR') {
      import('../../locale/br')
        .then(module => {
          this.localization.brMunicipalities = module.brMunicipalities
          this.localization.brTaxRegimes = module.brTaxRegimes
        })
        .catch(error => {
          console.error('Error loading one or many BR localization objects: ', error)
        })
    }
  },
  watch: {
    'customer.country' () {
      this.statesList = this.countriesList.find(country => country.id === this.customer.country).states
      this.customer.state = ''
      this.customer.tax_id = ''
    }
  },
  methods: {
    getList () {
      this.$store.dispatch('customers/LIST', {
        resource: 'customers',
        query: this.$route.query
      })
    },
    postCustomer () {
      this.$v.customer.$touch()

      if (this.$v.customer.$invalid) {
        return false
      }

      /**
       * Updates the `br_city_name` property of the `payload.tax_settings` object
       * if the `this.account.country.id` is equal to 'BR'.
       * @param {Object} payload - The payload object containing tax settings.
       */
      if (this.account.country.id === 'BR') {
        const brCityCode = this.localization.brMunicipalities.find(m => m.id === this.customer.tax_settings.br_city_code)
        this.customer.tax_settings.br_city_name = brCityCode.name
      }

      this.$store.dispatch('customers/CREATE', {
        resource: 'customers',
        payload: this.customer
      })
      .then((response) => {
        this.$router.push({ name: 'CustomerRetrieveUpdate', params: { id: response.data.id } })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    customer: {
      address: {
        required,
        maxLength: maxLength(64)
      },
      country: {
        required
      },
      currency: {
        required
      },
      email: {
        required,
        email,
        maxLength: maxLength(254)
      },
      manager: {
        maxLength: maxLength(64)
      },
      name: {
        required,
        maxLength: maxLength(100)
      },
      phone: {
        maxLength: maxLength(16)
      },
      state: {
        required
      },
      tax_id: {
        required: requiredIf(function () {
          return this.countriesList.find(country => country.id === this.customer.country).has_regulation
        }),
        taxId: function (val) {
          const country = this.countriesList.find(country => country.id === this.customer.country)

          if (country.has_regulation) {
            return validateTaxId(country.id, val)
          }

          return true
        },
        maxLength: maxLength(32)
      },
      tax_settings: {
        br_city_code: {
          required: requiredIf(function () {
            return this.account.country.id === 'BR'
          }),
          maxLength: maxLength(12)
        },
        br_municipal_tax_number: {
          maxLength: maxLength(32)
        },
        br_tax_regime: {
          required: requiredIf(function () {
            return this.account.country.id === 'BR'
          }),
          maxLength: maxLength(32)
        },
        cl_activity_description: {
          required: requiredIf(function () {
            return this.customer.country === 'CL'
          }),
          maxLength: maxLength(64)
        },
        mx_tax_scheme: {
          required: requiredIf(function () {
            return this.account.country.id === 'MX'
          }),
          maxLength: maxLength(3)
        }
      },
      website: {
        url
      },
      zip_code: {
        zip: function (val) {
          if (this.customer.country) {
            return validateZipCode(this.customer.country, val)
          }

          return true
        }
      }
    }
  }
}
</script>